import { render } from "./identification.vue?vue&type=template&id=ff17501e"
import script from "./identification.vue?vue&type=script&lang=ts"
export * from "./identification.vue?vue&type=script&lang=ts"
script.render = render

export default script